<template>
  <mdb-container class="gp-has-header">
    <div v-show="views.list">
      <data-table ref="orderList"
                  :click-handler="showOrder"
                  :columns="columns"
                  :dropdown-values="orderStatuses"
                  data-source="/order/list"
                  dropdown-filter
                  filterLabel="Filter on Order Status"
                  page-title="Orders"
      />
    </div>

    <div v-if="views.order">
      <div class="text-left">
        <mdb-btn icon="arrow-left" @click="toggleView('list')">Main</mdb-btn>
      </div>
      <mdb-card class="mb-4">
        <mdb-card-header class="secondary-color text-white">
          <h4>Customer</h4>
        </mdb-card-header>
        <mdb-card-body class="mb-1 text-left">
          <div class="text-right">
            <mdb-badge> {{ editingOrder.status }}</mdb-badge>
          </div>
          <h5>{{ editingOrder.customer.name }}</h5>
          <div>{{ editingOrder.customer.email }}</div>
          <div><b>Stripe Payment Confirmation: </b>{{ editingOrder.customer.stripePaymentConfirmation }}</div>
          <hr/>
          <h4>Ship To</h4>
          <gp-address :address="editingOrder.address"
                      :country="editingOrder.country"/>

        </mdb-card-body>
      </mdb-card>

      <mdb-card class="mb-4">
        <mdb-card-body class="mb-1 text-left">
          <cart-items :adminView="true"
                      :allowEdit="false"
                      :currentCart="editingOrder"
          />

          <mdb-btn v-if="editingOrder.status == 'SUBMITTED' || editingOrder.status == 'CANCELED'" color="success" icon="check"
                   @click="setStatus('PROCESSING')">Confirm - In Progress
          </mdb-btn>
          <mdb-btn v-if="editingOrder.status == 'PROCESSING' || editingOrder.status == 'CANCELED'" color="success" icon="check"
                   @click="setStatus('COMPLETE')">Complete Order
          </mdb-btn>
          <mdb-btn v-if="editingOrder.status != 'COMPLETE' && editingOrder.status != 'CANCELED'" color="danger" icon="minus-circle"
                   @click="setStatus('CANCELED')">Cancel Order
          </mdb-btn>

        </mdb-card-body>

      </mdb-card>
    </div>

  </mdb-container>
</template>

<script>
import dataTable from '../common/DataTable'
import api from '../../services/groupsPlaceApi.js'
import yesNoModal from "../common/YesNoModal";
import gpSelect from "../common/GPSelect";
import cartItems from "./CartItems";
import gpAddress from "../common/Address";

import {
  mdbBadge,
  mdbBtn,
  mdbCard,
  mdbCardBody,
  mdbCardHeader,
  mdbCardImage,
  mdbChip,
  mdbCol,
  mdbContainer,
  mdbIcon,
  mdbInput,
  mdbMask,
  mdbModal,
  mdbModalBody,
  mdbModalHeader,
  mdbRow,
  mdbTbl,
  mdbTblBody,
  mdbTblHead,
  mdbView
} from 'mdbvue';

export default {
  name: 'orders',
  components: {
    mdbContainer,
    mdbBtn,
    mdbChip,
    mdbModal,
    mdbModalHeader,
    mdbModalBody,
    mdbInput,
    mdbIcon,
    dataTable,
    mdbCard,
    mdbCardHeader,
    mdbCardBody,
    mdbCardImage,
    mdbRow,
    mdbCol,
    mdbMask,
    mdbView,
    mdbBadge,
    mdbTbl,
    mdbTblBody,
    mdbTblHead,
    yesNoModal,
    gpSelect,
    cartItems,
    gpAddress
  },
  filters: {
    formatNumber: function (val) {
      return val.toLocaleString(undefined, {minimumFractionDigits: 2})
    }
  },
  computed: {
    userDetails: function () {
      return this.$store.state.userDetails
    }
  },
  data() {
    return {
      currentOrder: null,
      editingOrder: null,
      editMode: false,
      views: {list: true, order: false},
      deleteCandidate: null,
      showCountryModal: false,
      showUserModal: false,
      editUserModal: false,
      editingUser: null,
      newEmail: null,
      showProductSearch: false,
      countries: [],
      currencies: [],
      savedProduct: null,
      yesNoModal: false,
      yesNoModal2: false,
      columns: [
        {label: "Id", field: "id"},
        {label: "Customer", field: "customer"},
        {label: "Status", field: "status"},
        {label: "Status Date", field: "statusDate"},
        {label: "Order Total", field: "totalDue", type: "number"}
      ],
      orderStatuses: [
        {text: "Submitted", value: "SUBMITTED", selected: true},
        {text: "Processing", value: "PROCESSING"},
        {text: "Canceled", value: "CANCELED"},
        {text: "Complete", value: "COMPLETE"}
      ]
    }
  }
  ,
  mounted() {
    if (this.$route.params.id) {
      let row = {id: this.$route.params.id}
      this.showOrder(row)
    }
  }
  ,
  methods: {
    toggleView(view) {
      for (const v in this.views) {
        if (view == v) this.views[v] = true
        else this.views[v] = false
      }
      if (view != "list") {
        this.$nextTick().then(() => {
          window.scrollTo(0, this.listScrollPos)
        })
      }
      if (view == "list") {
        this.$store.dispatch("setDataTableReload",true)
      }
    }
    ,
    showOrder: function (row) {
      this.$store.dispatch("setExecuting", true)
      api.get("/order/show/" + row.id).then(
        (response) => {
          this.editingOrder = response.data
          this.toggleView("order")
        },
        (error) => {
          this.showModal = false
          this.$notify.error({
                               message: "Error retrieving order. " + error.response.status,
                               timeOut: 5000,
                               position: 'top center'
                             })
        }
      ).then(() => {
        this.$store.dispatch("setExecuting", false)
      });
    },
    setStatus(status) {
      this.$store.dispatch("setExecuting", true)
      api.post("/order/status/" + this.editingOrder.id, {status: status}).then(
        (response) => {
          this.editingOrder.status = status
        },
        (error) => {
          this.showModal = false
          this.$notify.error({
                               message: error.response.data,
                               timeOut: 5000,
                               position: 'top center'
                             })
        }
      ).then(() => {
        this.$store.dispatch("setExecuting", false)
      });

    }

  }

}
;
</script>
